import { Component } from '@angular/core'
import { AgreementStatusDisplay } from '../../../../../../models/enum/agreement.enum'
import { ICustomTableColumnButton } from '../../modals/interface/custom-table.interface'
import { CustomTableService } from '../../service/custom-table.service'
import { DefaultRowComponent } from '../default-row/default-row.component'

@Component({
    selector: 'app-dispenser-agreement-history-row',
    templateUrl: './dispenser-agreement-history-row.component.html',
    styleUrls: ['./dispenser-agreement-history-row.component.scss'],
    standalone: false
})
export class DispenserAgreementHistoryRowComponent extends DefaultRowComponent {
  constructor(private customTableService: CustomTableService) {
    super()
  }

  public onClick(control: any): void {
    this.customTableService.clicked(control, this.row)
  }

  public displayActionButton(button: ICustomTableColumnButton) {
    return !button.displayInStatus || button.displayInStatus.includes(this.row['stateDisplay'])
  }

  public isCancelledStatus(): boolean {
    return this.row['stateDisplay'] === AgreementStatusDisplay.CANCELLED
  }
}
